export default {
  name: 'ImgBanner',
  data() {
    return {
      className: 'app__img-banner',
    };
  },
  props: {
    bgImage: {
      type: String,
      default: '',
    },
    mobileBgImage: {
      type: String,
      default: '',
    },
    imgAlt: {
      type: String,
      default: '',
    },
  },
  computed: {
    imgClassName() {
      return `${this.className}__img`;
    },
    imgMobileClassName() {
      return `${this.imgClassName}__mobile`;
    },
    imgDesktopClassName() {
      return `${this.imgClassName}__desktop`;
    },
  },
};
